/**
 * L3 明细**抽屉**（`AC-Q4.3` · 批 `82` 落地 · 批 `111` 瘦身为外壳）
 *
 * 🔴 **本文件只剩外壳**：`Drawer` + 右上角两个动作（「整页」/「关闭」）。
 * 三类行怎么画**一行都不在这里** —— 唯一实现在 `ContraTimelineBody.tsx`，
 * 与 `/debts/<contraId>` 页面**共用**（铁律 24：同一机制不许两个实现）。
 *
 * ## 为什么还要保留抽屉
 *
 * 卡片上点「明细」是**原地**看几行的场景（对比多张卡）。跳页会丢掉列表上下文，
 * 所以抽屉留着；「整页」按钮给需要深链接 / 长列表 / 想收藏的人。
 *
 * ⚠️ MUI `Drawer` 走 **Portal**：静态渲染拿不到抽屉内容（铁律 121）⇒
 * 任何"三类行画对了没"的断言必须打在 `ContraTimelineBody` 上，不能打在抽屉上。
 */

import type { ReactElement } from 'react';
import { Button, Drawer, IconButton, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ContraTimelineBody } from './ContraTimelineBody.js';

export interface ContraTimelineDrawerProps {
  /** `null` = 关闭 */
  accountId: string | null;
  onClose: () => void;
}

export function ContraTimelineDrawer({ accountId, onClose }: ContraTimelineDrawerProps): ReactElement {
  const navigate = useNavigate();
  const open = accountId !== null;
  const id = accountId ?? '';

  return (
    <Drawer anchor="right" open={open} onClose={onClose} data-testid="contra-timeline-drawer">
      {open && (
        <Stack sx={{ width: { xs: 320, sm: 420 } }}>
          <ContraTimelineBody
            accountId={id}
            actions={
              <>
                <Button
                  size="small"
                  onClick={() => {
                    onClose();
                    navigate(`/debts/${encodeURIComponent(id)}`);
                  }}
                  data-testid="contra-timeline-open-page"
                >
                  整页
                </Button>
                <IconButton size="small" onClick={onClose} aria-label="关闭" data-testid="contra-timeline-close">
                  ✕
                </IconButton>
              </>
            }
          />
        </Stack>
      )}
    </Drawer>
  );
}
